// extracted by mini-css-extract-plugin
export default {"optionsNavbar":"Navbar_optionsNavbar__8lvvP","btnLogin":"Navbar_btnLogin__jJH7u","logo":"Navbar_logo__aKDlM","logoMobile":"Navbar_logoMobile__8Y6PC"};